import React from "react";
import classes from "./winnersSection.module.css";
import SwipeCards from "../../../components/SwipingCard";
import { useNavigate } from "react-router-dom";

const WinnersSection = () => {
  const navigate = useNavigate();
  const handleStartCompeting = () => {
    navigate("/artist-next-door-arena/compete");
  };
  // Sample winners data
  const winners = [
    {
      id: 1,
      name: "Aditya Sharma",
      category: "Singing",
      prize: "₹50,000",
      testimonial:
        "ArtistNextDoor gave me a platform to showcase my talent to the world. I'm forever grateful for this opportunity!",
      image: "/api/placeholder/150/150",
    },
    {
      id: 2,
      name: "Priya Patel",
      category: "Dancing",
      prize: "₹45,000",
      testimonial:
        "Winning this competition has opened so many doors for me in the industry. Thank you ArtistNextDoor!",
      image: "/api/placeholder/150/150",
    },
    {
      id: 3,
      name: "Rahul Singh",
      category: "Photography",
      prize: "₹40,000",
      testimonial:
        "The exposure I got through this platform is incredible. My work is now being recognized by professionals.",
      image: "/api/placeholder/150/150",
    },
  ];

  return (
    <section className={classes.winnersSection} id="winners">
      <div className={classes.winnersSectionInner}>
        <div className={classes.sectionHeader}>
          <h2 className={classes.sectionTitle}>
            Recent <span className={classes.highlight}>Winners</span>
          </h2>
          <p className={classes.sectionDescription}>
            Meet the talented artists who topped our recent competitions
          </p>
        </div>

        {/* {winners.map((winner) => (
            <div key={winner.id} className={classes.winnerCard}>
              <div className={classes.winnerImageContainer}>
                <img
                  src={winner.image}
                  alt={winner.name}
                  className={classes.winnerImage}
                />
                <div className={classes.winnerCategoryBadge}>
                  {winner.category}
                </div>
              </div>
              <div className={classes.winnerInfo}>
                <h3 className={classes.winnerName}>{winner.name}</h3>
                <p className={classes.winnerPrize}>Won {winner.prize}</p>
                <div className={classes.testimonialContainer}>
                  <div className={classes.quoteIcon}>"</div>
                  <p className={classes.testimonial}>{winner.testimonial}</p>
                </div>
              </div>
            </div>
          ))} */}
        {/* <div className={classes.swipeCardsContainer}>
          <SwipeCards />
        </div> */}

        <div className={classes.becomewinner}>
          <div className={classes.becomeWinnerText}>
            <h3>Want to be our next winner?</h3>
            <p>
              Participate in our contests and showcase your talent to the world
            </p>
          </div>
          <button
            className={classes.startCompetingButton}
            onClick={handleStartCompeting}
          >
            Start Competing Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default WinnersSection;
